import * as React from "react";
function SvgCornersPlus(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M35.3 25.4v-2.8h-9.9v-9.9h-2.8v9.9h-9.9v2.8h9.9v9.9h2.8v-9.9h9.9zM1.4 14.1c.8 0 1.4-.6 1.4-1.4V2.8h9.9c.8 0 1.4-.6 1.4-1.4S13.5 0 12.7 0H1.4C.6 0 0 .6 0 1.4v11.3c0 .8.6 1.4 1.4 1.4zm11.3 31.1H2.8v-9.9c0-.8-.6-1.4-1.4-1.4S0 34.5 0 35.3v11.3c0 .8.6 1.4 1.4 1.4h11.3c.8 0 1.4-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4zM46.6 0H35.3c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4h9.9v9.9c0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4V1.4c0-.8-.6-1.4-1.4-1.4zm0 33.9c-.8 0-1.4.6-1.4 1.4v9.9h-9.9c-.8 0-1.4.6-1.4 1.4 0 .8.6 1.4 1.4 1.4h11.3c.8 0 1.4-.6 1.4-1.4V35.3c0-.8-.6-1.4-1.4-1.4z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCornersPlus);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
